import { render, staticRenderFns } from "./PublicReportStats.vue?vue&type=template&id=352470ce"
import script from "./PublicReportStats.vue?vue&type=script&lang=js"
export * from "./PublicReportStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports